import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::index
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:23
* @route '/admin/api-applications'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/api-applications',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::index
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:23
* @route '/admin/api-applications'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::index
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:23
* @route '/admin/api-applications'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::index
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:23
* @route '/admin/api-applications'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::index
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:23
* @route '/admin/api-applications'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::index
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:23
* @route '/admin/api-applications'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::index
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:23
* @route '/admin/api-applications'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::create
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:35
* @route '/admin/api-applications/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/admin/api-applications/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::create
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:35
* @route '/admin/api-applications/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::create
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:35
* @route '/admin/api-applications/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::create
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:35
* @route '/admin/api-applications/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::create
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:35
* @route '/admin/api-applications/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::create
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:35
* @route '/admin/api-applications/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::create
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:35
* @route '/admin/api-applications/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::store
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:46
* @route '/admin/api-applications'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/admin/api-applications',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::store
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:46
* @route '/admin/api-applications'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::store
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:46
* @route '/admin/api-applications'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::store
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:46
* @route '/admin/api-applications'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::store
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:46
* @route '/admin/api-applications'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::show
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:75
* @route '/admin/api-applications/{apiApplication}'
*/
export const show = (args: { apiApplication: string | number | { id: string | number } } | [apiApplication: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/admin/api-applications/{apiApplication}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::show
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:75
* @route '/admin/api-applications/{apiApplication}'
*/
show.url = (args: { apiApplication: string | number | { id: string | number } } | [apiApplication: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { apiApplication: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { apiApplication: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            apiApplication: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        apiApplication: typeof args.apiApplication === 'object'
        ? args.apiApplication.id
        : args.apiApplication,
    }

    return show.definition.url
            .replace('{apiApplication}', parsedArgs.apiApplication.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::show
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:75
* @route '/admin/api-applications/{apiApplication}'
*/
show.get = (args: { apiApplication: string | number | { id: string | number } } | [apiApplication: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::show
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:75
* @route '/admin/api-applications/{apiApplication}'
*/
show.head = (args: { apiApplication: string | number | { id: string | number } } | [apiApplication: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::show
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:75
* @route '/admin/api-applications/{apiApplication}'
*/
const showForm = (args: { apiApplication: string | number | { id: string | number } } | [apiApplication: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::show
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:75
* @route '/admin/api-applications/{apiApplication}'
*/
showForm.get = (args: { apiApplication: string | number | { id: string | number } } | [apiApplication: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::show
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:75
* @route '/admin/api-applications/{apiApplication}'
*/
showForm.head = (args: { apiApplication: string | number | { id: string | number } } | [apiApplication: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::destroy
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:86
* @route '/admin/api-applications/{apiApplication}'
*/
export const destroy = (args: { apiApplication: string | number | { id: string | number } } | [apiApplication: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/admin/api-applications/{apiApplication}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::destroy
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:86
* @route '/admin/api-applications/{apiApplication}'
*/
destroy.url = (args: { apiApplication: string | number | { id: string | number } } | [apiApplication: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { apiApplication: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { apiApplication: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            apiApplication: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        apiApplication: typeof args.apiApplication === 'object'
        ? args.apiApplication.id
        : args.apiApplication,
    }

    return destroy.definition.url
            .replace('{apiApplication}', parsedArgs.apiApplication.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::destroy
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:86
* @route '/admin/api-applications/{apiApplication}'
*/
destroy.delete = (args: { apiApplication: string | number | { id: string | number } } | [apiApplication: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::destroy
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:86
* @route '/admin/api-applications/{apiApplication}'
*/
const destroyForm = (args: { apiApplication: string | number | { id: string | number } } | [apiApplication: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::destroy
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:86
* @route '/admin/api-applications/{apiApplication}'
*/
destroyForm.delete = (args: { apiApplication: string | number | { id: string | number } } | [apiApplication: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::regenerate
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:97
* @route '/admin/api-applications/{apiApplication}/regenerate'
*/
export const regenerate = (args: { apiApplication: string | number | { id: string | number } } | [apiApplication: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: regenerate.url(args, options),
    method: 'post',
})

regenerate.definition = {
    methods: ["post"],
    url: '/admin/api-applications/{apiApplication}/regenerate',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::regenerate
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:97
* @route '/admin/api-applications/{apiApplication}/regenerate'
*/
regenerate.url = (args: { apiApplication: string | number | { id: string | number } } | [apiApplication: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { apiApplication: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { apiApplication: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            apiApplication: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        apiApplication: typeof args.apiApplication === 'object'
        ? args.apiApplication.id
        : args.apiApplication,
    }

    return regenerate.definition.url
            .replace('{apiApplication}', parsedArgs.apiApplication.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::regenerate
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:97
* @route '/admin/api-applications/{apiApplication}/regenerate'
*/
regenerate.post = (args: { apiApplication: string | number | { id: string | number } } | [apiApplication: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: regenerate.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::regenerate
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:97
* @route '/admin/api-applications/{apiApplication}/regenerate'
*/
const regenerateForm = (args: { apiApplication: string | number | { id: string | number } } | [apiApplication: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: regenerate.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ApiApplicationsController::regenerate
* @see app/Http/Controllers/Admin/ApiApplicationsController.php:97
* @route '/admin/api-applications/{apiApplication}/regenerate'
*/
regenerateForm.post = (args: { apiApplication: string | number | { id: string | number } } | [apiApplication: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: regenerate.url(args, options),
    method: 'post',
})

regenerate.form = regenerateForm

const apiApplications = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    show: Object.assign(show, show),
    destroy: Object.assign(destroy, destroy),
    regenerate: Object.assign(regenerate, regenerate),
}

export default apiApplications